import * as React from 'react';
import axios, { AxiosResponse } from 'axios';
import * as moment from 'moment';
import gql from 'graphql-tag';

import { Button, Card, Col, Divider, Modal, Row, Table, Input, notification } from 'antd';

import CustomerSelect from 'src/components/Others/CustomerSelect';
import PriceDisplay from 'src/components/Others/PriceDisplay';
import { withApollo } from 'react-apollo';
import ApolloClient from 'apollo-client';
import { GetCustomersQuery } from 'src/components/Query/Customers/Customers';
import CountrySelect from 'src/components/Others/CountrySelect';

import CountyStateSelect from 'src/components/Others/CountyStateSelect';
import { CountriesQuery } from 'src/components/Query/Countries/Countries';
import PaymentMethodSelect from 'src/components/Others/PaymentMethodSelect';
import DeliveryMethodSelect from 'src/components/Others/DeliveryMethodSelect';
import { addVAT } from 'helpers/src/prices/addVAT';
import { isProductCodeValid } from 'helpers/src/products/isProductCodeValid';

function createMarkup(content: string) {
  return { __html: content.replace(/(?:\r\n|\r|\n)/g, '<br />') };
}

interface IConfiguration {
  hash: string;
  createdAt: string;
  email: string;
  fullName: string;
  currency: string;
  nodes: {
    productCode: string;
    title: string;
    price: number;
    maximumDiscount?: number;
    appliedDiscount?: number;
    _codeValid: boolean;
    _codeChanged?: boolean;
  }[];
  setupDetails: {
    productCode: string;
    title: string;
    price: number;
    maximumDiscount?: number;
    appliedDiscount?: number;
    _codeValid: boolean;
    _codeChanged?: boolean;
  }[];
  accessories: {
    productCode: string;
    title: string;
    subtitle: string;
    price: number;
    maximumDiscount?: number;
    appliedDiscount?: number;
    _codeValid: boolean;
    _codeChanged?: boolean;
  }[];
  totalPrice: number;
  notes: string;
};

interface IConfiguratorState {
  customer: GQL.ICustomer | null,
  configuration: IConfiguration | null,
  loading: boolean,
  invoiceStateSelect: GQL.ICountryState[] | undefined;
  deliveryStateSelect: GQL.ICountryState[] | undefined;
  vatRate: number;
  paymentMethod: GQL.IPaymentMethod | undefined,
  paymentPrice: number,
  deliveryMethod: GQL.IDeliveryMethod | undefined,
  deliveryPrice: number,
  insurancePrice: number,
  accessoriesDiscount: number,
  libertyDiscount: number,
  orderIsCreating?: boolean;
  country?: GQL.ICountry;
  vatNumberValid?: boolean;
}

interface IcustomerProps {
  client: ApolloClient<any>,
  domain: string;
  hash: string;
  onClose: () => void
}

class ConfiguratorImport extends React.Component<IcustomerProps, IConfiguratorState> {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      configuration: null,
      customer: null,
      invoiceStateSelect: undefined,
      deliveryStateSelect: undefined,
      vatRate: 0,
      paymentMethod: undefined,
      paymentPrice: 0,
      deliveryMethod: undefined,
      deliveryPrice: 0,
      insurancePrice: 0,
      accessoriesDiscount: 0,
      libertyDiscount: 0,
    }
  }
  componentDidMount() {
    const { hash } = this.props;
    this.fetchConfigurator(hash);
  }

  addVAT = (price: number, vatRate: number = 0) => {
    return addVAT(price, vatRate);
  }

  changeCustomerField = (field: string, value: string) => {
    this.setState(({ customer }) => ({
      customer: {
        ...customer,
        [field]: value,
      } as GQL.ICustomer
    }), ['companyVatNumber', 'invoiceCountry', 'deliveryCountry'].indexOf(field) >= 0 ? () => {
      this.validateVatNumber();
    } : undefined)
  }

  public changeStateSelection = (country: GQL.ICountry, delivery: boolean = false) => {
    const states = country && Array.isArray(country.states) && (country.states.length > 0) && country.states || undefined;
    if (delivery) {
      this.setState({
        deliveryStateSelect: states,
        customer: {
          ...this.state.customer,
          deliveryCountyState: null,
        } as GQL.ICustomer,
      });
      return;
    }
    this.setState({
      invoiceStateSelect: states,
      customer: {
        ...this.state.customer,
        invoiceCountyState: null,
      } as GQL.ICustomer,
      country,
    });
  }

  private changeVATRate = (vatRate: number) => {
    this.setState({ vatRate: vatRate || 0 });
  };

  private changeLibertyDiscount(discount: number) {
    this.setState(({ configuration }) => ({
      libertyDiscount: discount,
      configuration: configuration ? {
        ...configuration,
        nodes: configuration.nodes.map(n => ({
          ...n,
          appliedDiscount: 'number' === typeof n.maximumDiscount
            ? Math.min(discount, n.maximumDiscount)
            : discount,
        })),
        setupDetails: configuration.setupDetails.map(s => ({
          ...s,
          appliedDiscount: 'number' === typeof s.maximumDiscount
            ? Math.min(discount, s.maximumDiscount)
            : discount,
        })),
      } : null,
    }));
  }

  private changeAccessoriesDiscount(discount: number) {
    this.setState(({ configuration }) => ({
      accessoriesDiscount: discount,
      configuration: configuration ? {
        ...configuration,
        accessories: configuration.accessories.map(a => ({
          ...a,
          appliedDiscount: 'number' === typeof a.maximumDiscount
            ? Math.min(discount, a.maximumDiscount)
            : discount,
        })),
      } : null,
    }));
  }

  private getNodes = (nodes: any, currency: string) => {
    const codes = nodes.filter(n => !!n.productCode).map(n => n.productCode);
    const validCodes = codes.filter(c => /#?\d+/.test(c));
    const code = validCodes[validCodes.length - 1];
    let result = '';
    // check if code is valid or is condition
    // if valid, return code
    if (code) {
      if (/^#?\d+$/.test(code)) {
        result = code;

        // if it's condition it has to be parsed and validated
      } else {
        const codeSet: Array<Array<any>> = Array.from(code.matchAll(/(EUR|USD)?(#[a-zA-Z]+)?(EUR|USD)?(#[a-zA-Z]+)?(#[a-zA-Z]+)?=?(#?\d+)/g));
        const match = codeSet.find((codeMatchPart: any[]) => {
          // if we evaluate currency, then go this way, in other case, fallback to next step
          if (codeMatchPart[1] || codeMatchPart[3]) {
            if (codeMatchPart[1] === currency || codeMatchPart[3] === currency) {
              return true;
            } else {
              return false;
            }
          }

          // 2, 4, 5 (condition) in case it's condition and not currency
          // we will try to find on these index matching codes in product combination
          return (codeMatchPart[2] ? codes.includes(codeMatchPart[2]) : true)
            && (codeMatchPart[4] ? codes.includes(codeMatchPart[4]) : true)
            && (codeMatchPart[5] ? codes.includes(codeMatchPart[5]) : true);

        }) || null;

        result = match && match[6];
        result = typeof result === 'string' && result.substr(0,1) !== '#' ? `#${result}` : result;
      }

      return nodes.map((n, index: number) => {
        return { ...n, productCode: index === 0 ? result : '' }
      });
    }

    // invalid order - old one
    return nodes;
  }

  public render() {
    const { configuration, customer, loading, paymentMethod, paymentPrice, deliveryMethod, deliveryPrice,
      insurancePrice, vatRate: countryVatRate, libertyDiscount, accessoriesDiscount, vatNumberValid } = this.state;
    const { onClose } = this.props;

    const vatRate = vatNumberValid ? 0 : countryVatRate;

    if (!configuration) {
      return null;
    }

    const singleInputStyle = { padding: '2px 5px', width: 300, margin: 3 };
    const selectInputStyle = { padding: '2px', width: 304 }
    const doubleInputStyle = { padding: '2px 5px', width: 146, margin: 3 };
    const numberInputStyle = { padding: '2px 5px', width: 140, margin: 3 };

    const cur = { value: configuration.currency } as GQL.ICurrency;
    const libertyPrice = this.addVAT(configuration.nodes.reduce((acc: number, n: any) => acc + n.price, 0), vatRate);
    const detailsPrice = this.addVAT(configuration.setupDetails.reduce((acc: number, n: any) => acc + n.price, 0), vatRate);
    const accessoriesPrice = this.addVAT(configuration.accessories.reduce((acc: number, n: any) => acc + n.price, 0), vatRate);


    // const libertyPriceWDiscount = (libertyPrice + detailsPrice) / 100 * (100 - libertyDiscount)
    // const accessoriesPriceWDiscount = accessoriesPrice / 100 * (100 - accessoriesDiscount);

    const libertyPriceWDiscount = this.addVAT(configuration.nodes.reduce((acc: number, n: IConfiguration['nodes'][number]) => acc + n.price / 100 * (100 - (n.appliedDiscount || 0)), 0), vatRate);
    const detailsPriceWDiscoiunt = this.addVAT(configuration.setupDetails.reduce((acc: number, n: IConfiguration['setupDetails'][number]) => acc + n.price / 100 * (100 - (n.appliedDiscount || 0)), 0), vatRate);
    const accessoriesPriceWDiscount = this.addVAT(configuration.accessories.reduce((acc: number, n: IConfiguration['accessories'][number]) => acc + n.price / 100 * (100 - (n.appliedDiscount || 0)), 0), vatRate);

    const grandTotal =
      libertyPrice + detailsPrice
      + accessoriesPrice + deliveryPrice + paymentPrice + insurancePrice


    const grandTotalWDiscount =
      + libertyPriceWDiscount + detailsPriceWDiscoiunt + accessoriesPriceWDiscount
      + deliveryPrice + paymentPrice + insurancePrice;

    return (
      <Modal
        maskClosable={false}
        title={`Importing order ${configuration.hash}`}
        onCancel={onClose}
        visible={true}
        width={'80%'}
        footer={[
          <Button key="back" onClick={onClose}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" loading={this.state.orderIsCreating} onClick={() => {
            this.createOrder();
          }}>
            Import order
          </Button>,
        ]}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Card
              type="inner"
              title="General"
              bordered={false}
            >
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Order Date</span>
                <span>
                  {moment(new Date(configuration.createdAt)).local().format('DD/MM/YY hh:mm:ss')}
                </span>
              </div>
            </Card>
            <Divider />
            <Card
              type="inner"
              title="Payment method"
              bordered={false}
            >
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Payment method</span>
                <span style={singleInputStyle}>
                  <PaymentMethodSelect
                    style={{ width: '100%' }}
                    name={'paymentMethodId'}
                    value={paymentMethod && paymentMethod.id}
                    onChange={(e: any, paymentMethod: GQL.IPaymentMethod | undefined) => this.setState({ paymentMethod })}
                  />
                </span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Payment price incl. VAT</span>
                <span>
                  <Input
                    type={'number'}
                    defaultValue={this.state.paymentPrice}
                    style={numberInputStyle}
                    addonAfter={configuration.currency}
                    required={true}
                    onBlur={(e) => this.setState({ paymentPrice: Number(e.target.value) })}
                  />
                </span>
              </div>
            </Card>
            <Divider />
            <Card
              type="inner"
              title="Delivery method"
              bordered={false}
            >
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Delivery method incl. VAT</span>
                <span style={singleInputStyle}>
                  <DeliveryMethodSelect
                    style={{ width: '100%' }}
                    name={'deliveryMethodId'}
                    value={deliveryMethod && deliveryMethod.id}
                    onChange={(e: any, deliveryMethod: GQL.IDeliveryMethod | undefined) => this.setState({ deliveryMethod })}
                  />
                </span>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Delivery price</span>
                <span>
                  <Input
                    type={'number'}
                    defaultValue={this.state.deliveryPrice}
                    style={numberInputStyle}
                    addonAfter={configuration.currency}
                    required={true}
                    onBlur={(e) => this.setState({ deliveryPrice: Number(e.target.value) })}
                  />
                </span>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Insurance price</span>
                <span>
                  <Input
                    type={'number'}
                    defaultValue={this.state.insurancePrice}
                    style={numberInputStyle}
                    addonAfter={configuration.currency}
                    onBlur={(e) => this.setState({ insurancePrice: Number(e.target.value) })}
                  />
                </span>
              </div>
            </Card>
            <Card type="inner" title="Discounts" bordered={false}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>CCR Liberty Discount</span>
                <span>
                  <Input
                    type={'number'}
                    defaultValue={this.state.libertyDiscount}
                    style={{ ...numberInputStyle, width: 130 }}
                    addonAfter={'%  '}
                    onBlur={(e) => this.changeLibertyDiscount(Number(e.target.value))}
                  />
                </span>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Accesories discount</span>
                <span>
                  <Input
                    type={'number'}
                    defaultValue={this.state.accessoriesDiscount}
                    style={{ ...numberInputStyle, width: 130 }}
                    addonAfter={'%  '}
                    onBlur={(e) => this.changeAccessoriesDiscount(Number(e.target.value))}
                  />
                </span>
              </div>


            </Card>
            <Divider />
            <Card type="inner" title="Summary" bordered={false}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Total excl. VAT</span>
                <span><PriceDisplay amount={configuration.totalPrice} currency={cur} /></span>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Total incl. VAT</span>
                <span><PriceDisplay amount={this.addVAT(configuration.totalPrice, vatRate)} currency={cur} /></span>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>VAT</span>
                <span>{'number' === typeof this.state.vatRate ? `${vatRate} %` : 'Receiving VAT Rate'}</span>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Delivery incl. VAT</span>
                <span><PriceDisplay amount={this.state.deliveryPrice} currency={cur} /></span>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Delivery insurance incl. VAT</span>
                <span><PriceDisplay amount={this.state.insurancePrice} currency={cur} /></span>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Payment incl. VAT</span>
                <span><PriceDisplay amount={this.state.paymentPrice} currency={cur} /></span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897', fontWeight: 'bold' }}>CCR Liberty</span>
                <span style={{ fontWeight: 'bold' }}>
                  {(libertyPrice + detailsPrice) != libertyPriceWDiscount
                    ? <><del><PriceDisplay amount={libertyPrice + detailsPrice} currency={cur} /></del>&nbsp;</>
                    : null
                  }
                  <PriceDisplay
                    amount={libertyPriceWDiscount}
                    currency={cur}
                  />
                </span>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897', fontWeight: 'bold' }}>Accessories</span>
                <span style={{ fontWeight: 'bold' }}>
                  {accessoriesPrice != accessoriesPriceWDiscount
                    ? <><del><PriceDisplay amount={accessoriesPrice} currency={cur} /></del>&nbsp;</>
                    : null
                  }
                  <PriceDisplay
                    amount={accessoriesPriceWDiscount}
                    currency={cur}
                  />
                </span>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897', fontWeight: 'bold' }}>Grand total</span>
                <span style={{ fontWeight: 'bold' }}>
                  {grandTotal != grandTotalWDiscount
                    ? <><del><PriceDisplay amount={grandTotal} currency={cur} /></del>&nbsp;</>
                    : null
                  }
                  <PriceDisplay
                    amount={grandTotalWDiscount}
                    currency={cur}
                  />
                </span>
              </div>
            </Card>
          </Col>
          <Col span={12}>
            <Card
              type="inner"
              title="Customer"
              bordered={false}
              loading={loading}
              extra={
                <div style={{ width: 300 }}>
                  <CustomerSelect
                    domain={this.props.domain}
                    onChange={(e) => { this.fetchCustomer(null, e.target.value) }}
                    name={'customer'} />
                </div>
              }
            >
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Fullname</span>
                <b>{configuration.fullName}</b>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>E-mail</span>
                <b>{configuration.email}</b>
              </div>
            </Card>
            {customer && <Card
              loading={loading}
              type="inner"
              title="Selected customer"
              bordered={false}
            >
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>E-mail</span>
                <Input
                  defaultValue={customer.email || ''}
                  style={singleInputStyle}
                  onBlur={(e) => this.changeCustomerField('email', e.target.value)}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Company</span>
                <Input
                  defaultValue={customer.companyName || ''}
                  style={singleInputStyle}
                  onBlur={(e) => this.changeCustomerField('companyName', e.target.value)}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Registration ID</span>
                <Input
                  defaultValue={customer.companyRegistrationNumber || ''}
                  style={singleInputStyle}
                  onBlur={(e) => this.changeCustomerField('companyRegistrationNumber', e.target.value)}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>VAT number</span>
                <Input
                  defaultValue={customer.companyVatNumber || ''}
                  style={(() => {
                    const style: React.CSSProperties = {...singleInputStyle};
                    if (false === this.state.vatNumberValid) {
                      style.borderColor = 'orange';
                    } else if (true === this.state.vatNumberValid) {
                      style.borderColor = 'green';
                    }
                    return style;
                  })()}
                  onBlur={(e) => this.changeCustomerField('companyVatNumber', e.target.value)}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Name</span>
                <span>
                  <Input
                    defaultValue={customer.invoiceFirstName || ''}
                    style={doubleInputStyle}
                    onBlur={(e) => this.changeCustomerField('invoiceFirstName', e.target.value)}
                  />
                  <Input
                    defaultValue={customer.invoiceLastName || ''}
                    style={doubleInputStyle}
                    onBlur={(e) => this.changeCustomerField('invoiceFirstName', e.target.value)}
                  />
                </span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Phone</span>
                <Input
                  defaultValue={customer.phone || ''}
                  style={singleInputStyle}
                  onBlur={(e) => this.changeCustomerField('phone', e.target.value)}
                />
              </div>

            </Card>}
            {customer && <Card
              type={'inner'}
              title="Invoicing" bordered={false}
              loading={loading}
            >
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Invoice name</span>
                <span>
                  <Input
                    defaultValue={customer.invoiceFirstName || ''}
                    style={doubleInputStyle}
                    onBlur={(e) => this.changeCustomerField('invoiceFirstName', e.target.value)}
                  />
                  <Input
                    defaultValue={customer.invoiceLastName || ''}
                    style={doubleInputStyle}
                    onBlur={(e) => this.changeCustomerField('invoiceLastName', e.target.value)}
                  />
                </span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Street address</span>
                <Input
                  defaultValue={customer.invoiceAddressLine1 || ''}
                  style={singleInputStyle}
                  onBlur={(e) => this.changeCustomerField('invoiceAddressLine1', e.target.value)}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Address line 2</span>
                <Input
                  defaultValue={customer.invoiceAddressLine2 || ''}
                  style={singleInputStyle}
                  onBlur={(e) => this.changeCustomerField('invoiceAddressLine2', e.target.value)}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>City & Zip</span>
                <span>
                  <Input
                    defaultValue={customer.invoiceCity || ''}
                    style={doubleInputStyle}
                    onBlur={(e) => this.changeCustomerField('invoiceCity', e.target.value)}
                  />
                  <Input
                    defaultValue={customer.invoiceZip || ''}
                    style={doubleInputStyle}
                    onBlur={(e) => this.changeCustomerField('invoiceZip', e.target.value)}
                  />
                </span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Country</span>
                <span>
                  <CountrySelect
                    name="invoiceCountry"
                    style={selectInputStyle}
                    value={customer.invoiceCountry || undefined}
                    hideRegions={false}
                    onChange={(e: any, country: GQL.ICountry) => {
                      this.changeVATRate(country.VATrate);
                      this.changeStateSelection(country);
                      this.changeCustomerField('invoiceCountry', country.name);
                      if (!country.code) {
                        notification['warning']({
                          message: 'Continent selected',
                          description: 'Country without assinged country code (probably a continent) selected, such order cannot be imported'
                        });
                      }
                    }}
                  />
                </span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>County / state</span>
                <span>
                  <CountyStateSelect
                    name={'invoiceCountyState'}
                    states={this.state.invoiceStateSelect || []}
                    style={selectInputStyle}
                    value={customer.invoiceCountyState || undefined}
                    onChange={(e: any, state: GQL.ICountryState) => {
                      this.changeVATRate(state.vatRate);
                      this.changeCustomerField('invoiceCountyState', state.name);
                    }}
                  />
                </span>
              </div>
            </Card>}
            {customer && <Card type={'inner'} title="Delivery" bordered={false}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Street address</span>
                <Input
                  defaultValue={customer.deliveryAddressLine1 || customer.invoiceAddressLine1 || ''}
                  style={singleInputStyle}
                  onBlur={(e) => this.changeCustomerField('deliveryAddressLine1', e.target.value)}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Address line 2</span>
                <Input
                  defaultValue={customer.deliveryAddressLine2 || customer.invoiceAddressLine2 || ''}
                  style={singleInputStyle}
                  onBlur={(e) => this.changeCustomerField('deliveryAddressLine2', e.target.value)}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>City & Zip</span>
                <span>
                  <Input
                    defaultValue={customer.deliveryCity || customer.invoiceCity || ''}
                    style={doubleInputStyle}
                    onBlur={(e) => this.changeCustomerField('deliveryCity', e.target.value)}
                  />
                  <Input
                    defaultValue={customer.deliveryZip || customer.invoiceZip || ''}
                    style={doubleInputStyle}
                    onBlur={(e) => this.changeCustomerField('deliveryZip', e.target.value)}
                  />
                </span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Country</span>
                <span>
                  <CountrySelect
                    style={selectInputStyle}
                    name={'country'}
                    value={customer.deliveryCountry || customer.invoiceCountry || undefined}
                    hideRegions={false}
                    onChange={(e: any, country: GQL.ICountry) => {
                      this.changeStateSelection(country, true);
                      this.changeCustomerField('deliveryCountry', country.name);
                    }}
                  />
                </span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>County / State</span>
                <span>
                  <CountyStateSelect
                    name={'deliveryCountyState'}
                    states={this.state.deliveryStateSelect || []}
                    style={selectInputStyle}
                    value={customer.deliveryCountyState || undefined}
                    onChange={(e: any, state: GQL.ICountryState) => this.changeCustomerField('deliveryCountyState', state.name)}
                  />
                </span>
              </div>
            </Card>}

            <h3>Notes from customer</h3>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              {!configuration.notes
                ? <span style={{ color: '#999897' }}>- empty -</span>
                : <span dangerouslySetInnerHTML={createMarkup(configuration.notes)} />}
            </div>
          </Col>
        </Row>
        <Divider />
        <Row gutter={16}>
          <Col span={24}>
            <Card
              title={`CCR Liberty unit`}
              bordered={false}
              headStyle={{ paddingLeft: 16, paddingRight: 16 }}
            >
              <Table
                rowKey={(record: any) => Math.random()}
                dataSource={configuration.nodes}
                pagination={false}
                footer={() => (
                  <Row>
                    <Col span={18}>
                      <strong>Total</strong>
                    </Col>
                    <Col span={6} style={{ textAlign: 'right' }}>
                      <PriceDisplay amount={libertyPrice} currency={cur} />
                    </Col>
                  </Row>
                )}
              >
                <Table.Column
                  title="#"
                  dataIndex="productCode"
                  key="productCode"
                  align="left"
                  width={'10%'}
                  render={(u, row: any, i) => {
                    return row.productCode;
                  }}
                />
                <Table.Column title="Title" dataIndex="title" key="title" align="left" width={'60%'} />
                <Table.Column title={<span>Maximal<br />discount</span>} dataIndex="maximumDiscount" key="maximumDiscount" align="right" width={'5%'} />
                <Table.Column title={<span>Price<br />excl. VAT</span>} dataIndex="price" key="price" align="right" width={'12%'} />
                <Table.Column
                  title={<span>Price<br />incl. VAT</span>}
                  key="priceWVat"
                  align="right" width={'12%'}
                  render={(row: any) => {
                    return this.addVAT(row.price);
                  }}
                />
              </Table>
            </Card>
          </Col>

          <Col span={24}>
            <Card
              title={`Details`}
              bordered={false}
              headStyle={{ paddingLeft: 16, paddingRight: 16 }}
            >
              <Table
                rowKey={(record: any) => Math.random()}
                dataSource={configuration.setupDetails}
                pagination={false}
                footer={() => (
                  <Row>
                    <Col span={18}>
                      <strong>Total</strong>
                    </Col>
                    <Col span={6} style={{ textAlign: 'right' }}>
                      <PriceDisplay amount={detailsPrice} currency={cur} />
                    </Col>
                  </Row>
                )}
              >
                <Table.Column
                  title="#"
                  dataIndex="productCode"
                  key="productCode"
                  align="left"
                  width={'10%'}
                  render={(u, row: any, i) => {
                    return row.productCode;
                  }}
                />
                <Table.Column title="Title" dataIndex="title" key="title" align="left" width={'60%'} />
                <Table.Column title={<span>Maximal<br />discount</span>} dataIndex="maximumDiscount" key="maximumDiscount" align="right" width={'5%'} />
                <Table.Column title={<span>Price<br />excl. VAT</span>} dataIndex="price" key="price" align="right" width={'12%'} />
                <Table.Column
                  title={<span>Price<br />incl. VAT</span>}
                  key="priceWVat"
                  align="right" width={'12%'}
                  render={(row: any) => this.addVAT(row.price, vatRate)}
                />
              </Table>
            </Card>
          </Col>

          <Col span={24}>
            <Card
              title={`Accessories`}
              bordered={false}
              headStyle={{ paddingLeft: 16, paddingRight: 16 }}
            >
              <Table
                rowKey={(record: any) => Math.random()}
                dataSource={configuration.accessories}
                pagination={false}
                footer={() => (
                  <Row>
                    <Col span={18}>
                      <strong>Total</strong>
                    </Col>
                    <Col span={6} style={{ textAlign: 'right' }}>
                      <PriceDisplay amount={accessoriesPrice} currency={cur} />
                    </Col>
                  </Row>
                )}
              >
                <Table.Column
                  title="#"
                  dataIndex="productCode"
                  key="productCode"
                  align="left"
                  width={'10%'}
                  render={(u, row: any, i) => {
                    const isCodeValid = isProductCodeValid(row.productCode);
                    return (
                      <Input
                        key={`${row.title}-${i}`}
                        defaultValue={(row._codeChanged || isCodeValid) && row.productCode || undefined}
                        style={(() => {
                          const style: React.CSSProperties = {};
                          if (row.productCode && row._codeChanged && !isCodeValid) {
                            style['borderColor'] = 'orange';
                          }
                          return style;
                        })()}
                        onBlur={(e: any) => {
                          const newProductCode = e.target.value;
                          this.setState(({ configuration }) => ({
                            configuration: ((newCode, nodeIndex) => {
                              if (configuration && Array.isArray(configuration.accessories)) {
                                configuration.accessories[nodeIndex].productCode = newCode;
                                configuration.accessories[nodeIndex]._codeChanged = true;
                              }
                              return configuration;
                            })(newProductCode, i)
                          }));
                        }}
                      />
                    );
                  }}
                />
                <Table.Column title="Title" dataIndex="title" key="title" align="left" width={'65%'} />
                <Table.Column title={<span>Maximal<br />discount</span>} dataIndex="maximumDiscount" key="maximumDiscount" align="right" width={'5%'} />
                <Table.Column title={<span>Amount</span>} dataIndex="count" key="price" align="right" width={'5%'} />
                <Table.Column title={<span>Price<br />excl. VAT</span>} dataIndex="price" key="price" align="right" width={'15%'} />
              </Table>
            </Card>
          </Col>
        </Row>
      </Modal>
    );
  }

  private fetchConfigurator(hash) {
    axios({
      method: 'post',
      url: 'https://divesoft-app.foxmedia.cz/graphql',
      headers: {
        'content-type': 'application/json',
      },
      data: JSON.stringify({
        operationName: null,
        variables: {},
        query: `{
          order(hash: "${hash}") {
            hash
            createdAt
            email
            totalPrice
            currency
            fullName
            notes
            nodes {
              productCode
              title
              price
              appliedDiscount
              maximumDiscount
            }
            accessories {
              productCode
              title
              subtitle
              price
              count
              appliedDiscount
              maximumDiscount
            }
            setupDetails {
              productCode
              title
              price
              appliedDiscount
              maximumDiscount
            }
          }
        }`
      }),
    }).then((res: AxiosResponse) => {
      if (res.status === 200 && !res.data.errors) {
        if (res && res.data && res.data.data) {
          const configuration = res.data.data.order;
          configuration.nodes = this.getNodes(configuration.nodes, configuration.currency);
          configuration.nodes = configuration.nodes.map((n) => ({
            ...n,
            _codeValid: isProductCodeValid(n.productCode, true),
          }));
          configuration.setupDetails = configuration.setupDetails.map((s) => ({
            ...s,
            _codeValid: isProductCodeValid(s.productCode, true),
          }));
          configuration.accessories = configuration.accessories.map((a) => ({
            ...a,
            _codeValid: isProductCodeValid(a.productCode, true),
          }));

          // liberty discount and accessories discount should be the maximal discount found, the lower discount should be caused by limitations of maximal discount
          const libertyDiscount = Math.max(
            configuration.nodes.reduce((acc: number, n) => Math.max(acc, (n.appliedDiscount || 0)), 0),
            configuration.setupDetails.reduce((acc: number, s) => Math.max(acc, (s.appliedDiscount || 0)), 0),
          );
          const accessoriesDiscount = configuration.accessories.reduce((acc: number, a) => Math.max(acc, (a.appliedDiscount || 0)), 0);

          this.setState({
            configuration,
            libertyDiscount,
            accessoriesDiscount,
          });
          this.fetchCustomer(res.data.data.order.email);
        }
      } else {
        notification['error']({
          message: 'Order has not been found!'
        })
        this.setState({ configuration: null });
        this.props.onClose();
      }
    })
  }

  private fetchCustomer(email, id?) {
    if (!email && !id) {
      return;
    }

    this.setState({ loading: true, customer: null }, () => {
      const { client, domain } = this.props;
      const res = client.query({
        query: GetCustomersQuery,
        variables: {
          filterSearch: email,
          eshopDomain: domain,
          id: id
        }
      });

      res.then((res) => {
        if (res && res.data && res.data.customers && res.data.customers[0]) {
          const customer = res.data.customers[0] as GQL.ICustomer;
          this.setState({ customer: res.data.customers[0], loading: false, vatNumberValid: undefined });
          this.fetchCountry(customer.invoiceCountry as string, customer.invoiceCountyState || undefined)
            .then(() => {
              if (customer.companyVatNumber) {
                this.validateVatNumber();
              }
            })
        } else {
          this.setState({ loading: false })
        }
      });
    });
  }

  private fetchCountry(countryName: string, stateName?: string) {
    const { client } = this.props;
    const res = client.query({
      query: CountriesQuery,
      variables: {
        search: countryName,
      }
    });

    return res.then((res) => {
      if (res && res.data && Array.isArray(res.data.countries) && (res.data.countries.length > 0)) {
        const country = res.data.countries.find((c: GQL.ICountry) => c.name.toLowerCase() === countryName.toLowerCase());
        if (country) {
          if ('string' === typeof stateName) {
            const state = Array.isArray((country as GQL.ICountry).states) && (country as GQL.ICountry).states?.find(s => s.name.toLowerCase() === stateName.toLowerCase()) || undefined;
            if (state) {
              this.setState({ vatRate: state.vatRate });
            } else {
              // if state not found, use county VAT Rate!
              console.error(`State ${stateName} not found`);
              this.setState({ vatRate: (country as GQL.ICountry).VATrate });
            }
          } else {
            this.setState({ vatRate: (country as GQL.ICountry).VATrate });
          }
          this.setState(() => ({ country }));
        } else {
          console.error(`Country ${countryName} not found`);
        }
      }
    });
  }

  private fetchVariants(productCodes: string[]) {
    const { client } = this.props;
    const query = client.query({
      query: gql`
        query($productCodes: [String!]) {
          variants(where: {sku_in: $productCodes}) {
            sku
            prices
            definition
            product {
              prices {
                currencyId
                minimalPrice
              }
            }
          }
        }
      `,
      variables: {
        productCodes,
      }
    });

    query.then((res) => {
      if (res && res.data && res.data.variants) {
        return res.data.variants;
      }
      return null;
    });
  }

  private createOrder() {
    const { client } = this.props;
    const { configuration } = this.state;
    if (!configuration) {
      notification['error']({
        description: 'Imported order does not exist',
        message: 'Not Imported',
      });
      return;
    }

    this.setState({ orderIsCreating: true });

    const ImportOrder = gql`
      mutation($order: ImportedConfiguratorOrder!, $domain: String!) {
        importOrderFromConfigurator(
          order: $order
          domain: $domain
        ) {
          id
          orderNumber
        }
      }
    `;

    const libertyProductCodeNodeIndex = configuration.nodes.findIndex((n) => n.productCode);
    const libertyProductCode = (libertyProductCodeNodeIndex >= 0) && configuration.nodes[libertyProductCodeNodeIndex].productCode || undefined;

    if (!libertyProductCode || (libertyProductCodeNodeIndex !== 0)) {
      notification['error']({
        description: 'Liberty product code not found',
        message: 'Liberty Code',
      });
      return;
    }

    client.mutate({
      mutation: ImportOrder,
      variables: {
        order: {
          configuration: this.state.configuration,
          customer: this.state.customer,
          payment: this.state.paymentMethod,
          paymentPrice: this.state.paymentPrice,
          delivery: this.state.deliveryMethod,
          deliveryPrice: this.state.deliveryPrice,
          insurancePrice: this.state.insurancePrice,
          vatRate: this.state.vatNumberValid ? 0 : this.state.vatRate,
          accessoriesDiscount: this.state.accessoriesDiscount,
          libertyDiscount: this.state.libertyDiscount,
          libertyProductCode,
          companyVatNumberValid: this.state.vatNumberValid,
        },
        domain: this.props.domain,
      },
    })
      .then((res) => {
        const orderNumber = res && res.data && res.data.importOrderFromConfigurator && res.data.importOrderFromConfigurator.orderNumber || undefined;
        this.setState({ orderIsCreating: false });
        notification['success']({
          description: orderNumber && `Created order number ${orderNumber}` || 'Created order from configurator',
          message: 'Order created',
        });
      })
      .catch((e) => {
        this.setState({ orderIsCreating: false });
        // debugger;
        notification['error']({
          message: 'Error while creating order',
          description: e?.graphQLErrors[0]?.message || 'Unkown error',
        });
      });
  }

  private validateVatNumber() {
    const endpoint = process.env.REACT_APP_VAT_VALIDATOR_ENDPOINT;
    this.setState(() => ({ vatNumberValid: undefined }));

    if ((!this.state.customer)
      || (!this.state.customer.companyVatNumber)
      || (('string' === typeof this.state.customer.companyVatNumber) && (this.state.customer.companyVatNumber.trim().length < 1))
    ) {
      return;
    }

    axios({
      method: 'POST',
      url: endpoint + '/orders/vat-validator',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        email: this.state.customer.email,
        country: this.state.country && this.state.country.name || undefined,
        vatNumber: this.state.customer && this.state.customer.companyVatNumber || undefined,
      }
    })
    .then((result) => {
      const resultData = result && result.data || {};

      if (true !== resultData.error) {
        this.setState(() => ({ vatNumberValid: resultData.valid === true }));
      } else {
        notification['error']({
          message: 'VAT validation failed',
          description: 'An error occured while validating VAT',
        });
      }
    })
    .catch((err) => {
      notification['error']({
        message: 'VAT validation failed',
        description: 'An error occured during VAT validation',
      });
      console.log(err);
    })
  }
}

export default withApollo(ConfiguratorImport);



// WEBPACK FOOTER //
// ./src/scenes/Orders/components/ConfiguratorImport.tsx